import React, { Component } from 'react';
import { Radio } from 'synfrastructure';
import ToggleScaffold from '../../common/forms/ToggleScaffold';

class Radios extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedRadio: null,
    };
  }

  toggleRadio(e) {
    this.setState({ checkedRadio: e.target.value });
  }

  render() {
    const options = ['True', 'False'];

    return (
      <div className="paper">
        <div className="styleguide__title">Radio Inputs</div>
        <div className="styleguide__row">
          {options.map(option => {
            const optionLabel = `${option.charAt(0).toUpperCase()}${option.substr(1)}`;
            return (
              <ToggleScaffold
                key={option}
                label={optionLabel}
                disabled={option === 'disabled'}
                className={this.state.checkedRadio === option ? 'checked' : ''}
              >
                <Radio
                  id={option}
                  value={option}
                  checked={this.state.checkedRadio === option}
                  onChange={this.toggleRadio.bind(this)}
                  disabled={option === 'disabled'}
                />
              </ToggleScaffold>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Radios;



// WEBPACK FOOTER //
// ./src/style-guide/sections/Radios.js